import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IDeliveryNote } from "mobx-stores/_models/delivery-note/delivery-note";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import {
  DetailIconButton,
  ExpandButton,
} from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const DeliveryNoteTable = observer(() => {
  const {
    deliveryNoteManagement: {
      deliveryNotes,
      getDeliveryNotes,
      pagination,

      searchConditionAsNaturalLanguageNode,
    },
  } = useStores();

  useEffect(() => {
    getDeliveryNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getDeliveryNotes();
    },
    [getDeliveryNotes, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguageNode}
    >
      <TableHead>
        <TableRow>
          <TableCell rowSpan={2}></TableCell>
          <TableCell rowSpan={2}>STT</TableCell>
          <TableCell rowSpan={2}>Ngày</TableCell>
          <TableCell rowSpan={2}>Số Phiếu</TableCell>
          <TableCell rowSpan={2}>Tên giao dịch</TableCell>
          <TableCell rowSpan={2}>Đơn đặt hàng</TableCell>
          <TableCell colSpan={4} align="center">
            Chi tiết vận chuyển
          </TableCell>
          <TableCell rowSpan={2}></TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ top: "50px" }}>Người giao</TableCell>
          <TableCell sx={{ top: "50px" }}>Biển số</TableCell>
          <TableCell sx={{ top: "50px" }}>Địa chỉ</TableCell>
          <TableCell sx={{ top: "50px" }}>Ghi chú</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {deliveryNotes.map((x, i) => (
          <Row data-id={x.id} key={x.id} deliveryNote={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  deliveryNote: IDeliveryNote;
};
const Row = observer(({ deliveryNote }: RowProps) => {
  const {
    deliveryNoteManagement: { setProp },
  } = useStores();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const goDetailHandler = useCallback(
    (order: IDeliveryNote) => {
      navigate(`${order.id}`);
      setProp("deliveryNoteDetail", cloneDeep(order));
    },
    [navigate, setProp],
  );
  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{deliveryNote.orderNumber || ""}</TableCell>
        <TableCell>{dateTimeDisplay(deliveryNote.date || "")}</TableCell>
        <TableCell>{deliveryNote.number || ""}</TableCell>
        <TableCell>
          {deliveryNote.customer ? (
            <CustomerDealingAndActiveInfo
              customer={deliveryNote.customer}
            ></CustomerDealingAndActiveInfo>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell>{deliveryNote.purchaseOrder?.poNumber || ""}</TableCell>
        <TableCell>{deliveryNote.man || ""}</TableCell>
        <TableCell>{deliveryNote.licensePalate || ""}</TableCell>
        <TableCell>{deliveryNote.deliveryAddress?.address || ""}</TableCell>
        <TableCell>{deliveryNote.note || ""}</TableCell>
        <TableCell width={"20px"}>
          <DetailIconButton
            onClick={() => goDetailHandler(deliveryNote)}
          ></DetailIconButton>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={11} headerTitle="Chi tiết mặt hàng">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2}>Tên hàng</TableCell>
                  <TableCell rowSpan={2}>Mã hàng</TableCell>
                  <TableCell rowSpan={2}>Mã vạch</TableCell>
                  <TableCell rowSpan={2}>ĐVT</TableCell>
                  <TableCell colSpan={4} align="center">
                    Chi tiết giao hàng
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>SL (pcs)</TableCell>
                  <TableCell>TL (kg)</TableCell>
                  <TableCell>M/H</TableCell>
                  <TableCell>Kiện</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveryNote.items.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {item.product ? (
                        <ProductNameAndActiveInfo
                          product={item.product}
                        ></ProductNameAndActiveInfo>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell>{item.product?.code || ""}</TableCell>
                    <TableCell>{item.product?.barcode || ""}</TableCell>
                    <TableCell>
                      {item.product?.unitOfCalculation || ""}
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.amount}></NumberText>
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.weight}></NumberText>
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.mh}></NumberText>
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.package}></NumberText>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
